<template>
    <form-validation v-slot="{ bindings: validationBindings }">
        <side-sheet
            ref="actionForm"
            :size="width"
            label="Actie formulier"
            description="Hier kan je een actie aanmaken of wijzigen"
            has-reopen
        >
            <template #default>
                <div class="action-sidesheet">
                    <grid-container :template="chosen > 0 ? 'side-sheet-two-columns' : 'side-sheet'">
                        <grid-area area="side-sheet-header">
                            <div class="sidesheet-header">
                                <text-decorator bold>
                                    Actie toevoegen
                                </text-decorator>
                            </div>
                        </grid-area>
                        <grid-area
                            class="action-sidesheet__grid-area"
                            :area="chosen > 0 ? 'left' : 'side-sheet-content'"
                            wrap
                            scroll
                        >
                            <div class="action-sidesheet__toggles">
                                <input-group v-if="false" v-model="form.realworksEnabled">
                                    <template #label>
                                        <input-label>
                                            Opslaan in realworks?
                                        </input-label>
                                    </template>
                                    <template #input>
                                        <toggle-input v-if="false">
                                            <template #labelActive>
                                                Ja
                                            </template>
                                            <template #labelInactive>
                                                Nee
                                            </template>
                                        </toggle-input>
                                        <text-decorator v-if="true">
                                            {{ 'Nee' }}
                                        </text-decorator>
                                    </template>
                                </input-group>

                                <input-group
                                    v-model="form.isTask"
                                    @input="form.type = defaultTypeValue"
                                >
                                    <template #label>
                                        <input-label>
                                            Soort actie?
                                        </input-label>
                                    </template>
                                    <template #input>
                                        <toggle-input v-if="!isExistingAction">
                                            <template #labelActive>
                                                Taak
                                            </template>
                                            <template #labelInactive>
                                                Afspraak
                                            </template>
                                        </toggle-input>
                                        <text-decorator v-else>
                                            {{ actionType === 'task' ? 'Taak' : 'Afspraak' }}
                                        </text-decorator>
                                    </template>
                                </input-group>
                            </div>
                            <div class="action-sidesheet__form">
                                <input-group v-model="form.type" :schema="object({ value: string().required(`Soort is verplicht`) })">
                                    <template #label>
                                        <input-label>
                                            Soort {{ form.isTask ? 'taak' : 'afspraak' }}
                                        </input-label>
                                    </template>
                                    <template #input>
                                        <select-input
                                            :items="types"
                                            :disabled="isExistingAction"
                                        />
                                    </template>
                                </input-group>

                                <input-group v-model="form.responsible">
                                    <template #label>
                                        <input-label>
                                            Verantwoordelijk
                                        </input-label>
                                    </template>
                                    <template #input>
                                        <multi-select-input
                                            :items="orderedUserCollection"
                                            value-key-name="id"
                                            label-key-name="name"
                                            :max-selectable="3"
                                        >
                                            <template #active-label="{ bindings }">
                                                <span>
                                                    <chip-avatar>
                                                        <user-avatar
                                                            :placeholder="bindings.value.name.abbreviation"
                                                            size="md"
                                                            :url="bindings.value.avatar ? resizedToSizeUploadUrl(bindings.value.avatar, 'md') : ''"
                                                            :alt="bindings.value.name"
                                                        />
                                                        <span>{{ bindings.value.name.fullName }}</span>
                                                    </chip-avatar>
                                                </span>
                                            </template>
                                            <template #item="{ bindings }">
                                                <span style="display:flex; align-items: center;">
                                                    <user-avatar
                                                        :placeholder="bindings.item.name.abbreviation"
                                                        size="md"
                                                        :url="bindings.item.avatar ? resizedToSizeUploadUrl(bindings.item.avatar, 'md') : ''"
                                                        :alt="bindings.item.name"
                                                    />
                                                    <span>&nbsp;{{ bindings.item.name.fullName }}</span>
                                                </span>
                                            </template>
                                        </multi-select-input>
                                    </template>
                                </input-group>

                                <div class="action-sidesheet__time-select">
                                    <input-group v-model="form.startDateChosen">
                                        <template #label>
                                            <input-label>
                                                Datum
                                            </input-label>
                                        </template>
                                        <template #input>
                                            <date-input type="date" />
                                        </template>
                                    </input-group>
                                    <input-group v-model="form.startDateChosen">
                                        <template #label>
                                            <input-label>
                                                Tijd
                                            </input-label>
                                        </template>
                                        <template #input>
                                            <date-input type="time" />
                                        </template>
                                    </input-group>
                                    <template v-if="!form.isTask">
                                        <span>
                                            <text-decorator
                                                :color="Color.gray400"
                                                :size="FontSize.sm"
                                            >
                                                tot
                                            </text-decorator>
                                        </span>
                                        <input-group v-model="form.endDateChosen">
                                            <template #input>
                                                <date-input type="time" />
                                            </template>
                                        </input-group>
                                    </template>
                                </div>
                                <input-group v-model="form.comment">
                                    <template #label>
                                        <input-label>
                                            Opmerking (optioneel)
                                        </input-label>
                                    </template>
                                    <template #input>
                                        <rich-text-area-input :mentionables="[]" />
                                    </template>
                                </input-group>
                            </div>
                            <div class="action-sidesheet__actions">
                                <div>
                                    <input-group v-model="form.informAssignedTo">
                                        <template #input="{ bindings }">
                                            <flex-container
                                                align-items="center"
                                                gap="sm"
                                                no-wrap
                                            >
                                                <checkbox-input label="Informeer verantwoordelijke" />
                                                <text-decorator :size="FontSize.sm" style="user-select: none">
                                                    <label :for="bindings.ids.input">Informeer verantwoordelijke</label>
                                                </text-decorator>
                                            </flex-container>
                                        </template>
                                    </input-group>
                                </div>

                                <button-outline
                                    v-if="actionForm && isExistingAction"
                                    :color="Color.red500"
                                    @click="showDeleteConfirmation"
                                >
                                    Verwijderen
                                </button-outline>

                                <div style="display: flex; flex-grow: 1" />

                                <button-outline v-if="actionForm" @click="actionForm.dispatchOverlayEvent('exit')">
                                    Annuleren
                                </button-outline>
                                <button-block :disabled="!validationBindings.isValid.value" @click="onSave">
                                    Opslaan
                                </button-block>
                            </div>
                        </grid-area>

                        <grid-area
                            v-if="chosen"
                            area="right"
                            wrap
                            scroll
                        >
                            <div class="action-sidesheet__calendar">
                                <input-group
                                    v-model="form.startDateChosen"
                                >
                                    <template #input>
                                        <availability-calendar-input
                                            :default-unavailable-time-in-minutes="60"
                                            :slots-size-in-minutes="60"
                                            :hours-from="7"
                                            :minutes-from="0"
                                            :hour-to="18"
                                            :minutes-to="0"
                                            :appointments="mappedAppointmentsAndTasks"
                                            appointments-date-from-key="start"
                                            appointments-date-to-key="end"
                                            appointments-owner-key="ownerId"
                                            :calendars="mappedCalendars"
                                            calendars-avatar-key="avatar"
                                            calendars-id-key="id"
                                            calendars-short-name-key="name"
                                            :selected-date="!form.startDateChosen ? new Date() : form.startDateChosen "
                                        />
                                    </template>
                                </input-group>
                            </div>
                        </grid-area>
                    </grid-container>
                </div>
            </template>
        </side-sheet>
    </form-validation>

    <confirmation-dialog
        ref="deleteConfirmDialog"
        :label="`Weet u zeker dat u deze ${actionLabel} wilt verwijderen?`"
        :description="`U probeert deze ${actionLabel} te verwijderen, dit kan niet teruggedraaid worden. Weet u dit zeker?`"
    >
        <template #default>
            <text-heading>Weet u zeker dat u deze {{ actionLabel }} wilt verwijderen?</text-heading>
            <p>
                Dit kan niet teruggedraaid worden.<br>
                Weet u dit zeker?
            </p>
        </template>
        <template #actions="{ bindings }">
            <button-outline @click="bindings.overlay.closeOverlay();">
                Annuleren
            </button-outline>
            <button-block @loading="deleteAction">
                Verwijderen
            </button-block>
        </template>
    </confirmation-dialog>
</template>

<script setup lang="ts">
    import {
        Color,
        type ExposedOverlay,
        FontSize,
        NotificationBlock,
        SideSheet,
        TextDecorator,
        UserAvatar,
        GridContainer,
        GridArea,
        InputGroup,
        InputLabel,
        SelectInput,
        MultiSelectInput,
        ChipAvatar,
        DateInput,
        RichTextAreaInput,
        CheckboxInput,
        ButtonOutline,
        ButtonBlock,
        AvailabilityCalendarInput,
        ToggleInput,
        ConfirmationDialog,
        TextHeading,
        ButtonState,
        type ButtonStateChangedEvent,
    } from '@keyvue/one-ui';

    import { resizedToSizeUploadUrl } from '@/utils/resize';
    import { sendTaskTiming, startTaskCreation, stopTaskCreation } from '@/utils/taskTiming';
    import type { TaskCreation } from '@/utils/taskTiming';
    import { computed, onMounted, ref, watch } from 'vue';
    import { Team, Lead, LeadId, TaskId, AppointmentId, TaskType, AppointmentType, User, Task, Appointment } from '@keyvue/one-api-client';
    import { ActionAPI, UserAPI, ReferralAPI, createResourceIdentifier } from '@keyvue/one-api-client-legacy';
    import { useRoute, useRouter } from 'vue-router';
    import { v4 as uuid } from 'uuid';
    import useClient from '@composables/useClient';
    import useNotify from '@composables/useNotify';
    import useOverlayAsRoute from '@composables/useOverlayAsRoute';
    import useParentRoute from '@composables/useParentRoute';
    import useEventBus from '@composables/useEventBus';
    import { object, string } from 'yup';

    const createRouteLocation = useParentRoute();
    const route = useRoute();
    const router = useRouter();
    const { client, getLazyReactiveCollection } = useClient();
    const { notify, notifySaving, notifyDeleted, notifyError } = useNotify();
    const eventBus = useEventBus();

    const actionForm = ref<ExposedOverlay<'open' | 'close' | 'exit'>>();
    const deleteConfirmDialog = ref<ExposedOverlay<'open' | 'close' | 'exit'>>();
    const actionLabel = computed(() => (actionType.value === 'task' ? 'taak' : 'afspraak'));

    useOverlayAsRoute({
        overlay: actionForm,
        isSideSheet: true,
        redirectMethod: () => {
            redirectToDetail();
        },
        reloadMethod: async () => {
            await loadUsers();
            await loadCurrentTaskOrAppointment();
        },
    });

    const initialStartDate = new Date();
    initialStartDate.setHours(initialStartDate.getHours() + 1);
    initialStartDate.setMinutes(0);

    const initialEndDate = new Date(initialStartDate);
    initialEndDate.setHours(initialEndDate.getHours() + 1);

    const lead = ref<Lead | null>(null);
    const appointment = ref<Appointment | null>(null);
    const task = ref<Task | null>(null);
    const defaultTypeValue = ref({ value: null, label: 'Kies een soort' });

    const form = ref<{
        realworksEnabled: boolean,
        isTask: boolean,
        informAssignedTo: boolean,
        type: { value: TaskType | AppointmentType | null, label: string },
        responsible: User[],
        startDateChosen: Date,
        endDateChosen: Date,
        comment: string,
    }>({
        realworksEnabled: false,
        isTask: false,
        informAssignedTo: false,
        type: defaultTypeValue.value,
        responsible: [],
        startDateChosen: initialStartDate,
        endDateChosen: initialEndDate,
        comment: '',
    });

    const responsibleUserIds = computed(() => (
        form.value.responsible.map((user) => (user.id.value))
    ));

    const userCollection = ref<{ data: User[], total: number }>();

    const appointmentCollection = ref(await getLazyReactiveCollection(Appointment, {
        'assignedUsers.id': responsibleUserIds.value,
        'startDateTime[before]': (() => {
            const newDate = new Date(form.value.startDateChosen);
            newDate.setHours(23, 59, 59, 999);
            return newDate;
        })(),
        'startDateTime[after]': (() => {
            const newDate = new Date(form.value.startDateChosen);
            newDate.setHours(0, 0, 0, 0);
            return newDate;
        })(),
        pagination: false,
    }));

    const taskCollection = ref(await getLazyReactiveCollection(Task, {
        'assignedUsers.id': responsibleUserIds.value,
        'dueDateTime[before]': (() => {
            const newDate = new Date(form.value.startDateChosen);
            newDate.setHours(23, 59, 59, 999);
            return newDate;
        })(),
        'dueDateTime[after]': (() => {
            const newDate = new Date(form.value.startDateChosen);
            newDate.setHours(0, 0, 0, 0);
            return newDate;
        })(),
        pagination: false,
    }));

    const orderedUserCollection = computed(() => (
        [...(userCollection.value?.data ?? [])].sort((a, b) => a.name.fullName.localeCompare(b.name.fullName))
    ));

    const types = computed(() => (
        (form.value.isTask ? TaskType.values : AppointmentType.values).map((type) => ({
            value: type,
            label: type.label,
        }))
    ));

    const chosen = computed(() => form.value.responsible.length);

    const startDateChosen = computed(() => form.value.startDateChosen);

    const width = computed(() => {
        if (chosen.value === 0) {
            return 5;
        }

        return 6 + chosen.value;
    });

    const mappedAppointments = computed(() => {
        const map: object[] = [];

        appointmentCollection.value.data.forEach((mappableAppointment) => {
            mappableAppointment.assignedUsers.forEach((user) => {
                map.push({
                    ownerId: user.id.value,
                    start: mappableAppointment.startDateTime,
                    end: mappableAppointment.endDateTime,
                });
            });
        });

        return map;
    });

    const mappedTasks = computed(() => {
        const map: object[] = [];

        taskCollection.value.data.forEach((mappableTask) => {
            mappableTask.assignedUsers.forEach((user) => {
                const endDate = new Date(mappableTask.dueDateTime.toString());
                endDate.setHours(endDate.getHours() + 1);

                map.push({
                    ownerId: user.id.value,
                    start: mappableTask.dueDateTime,
                    end: null,
                });
            });
        });

        return map;
    });

    const actionId = computed(() => route.params.actionId?.toString());

    const actionType = computed(() => route.params.actionType?.toString());

    const mappedAppointmentsAndTasks = computed(() => ([
        ...mappedAppointments.value,
        ...mappedTasks.value,
    ]));

    const isExistingAction = computed(() => (
        actionType.value === 'task' || actionType.value === 'appointment'
    ));

    const mappedCalendars = computed(() => (
        form.value.responsible.map((user) => ({
            id: user.id.value,
            name: user.name.abbreviation,
            avatar: user.avatar,
        }))
    ));

    // UX measurement: how long creating a task or appointment takes, and which defaults people change
    let creation: TaskCreation | undefined;

    onMounted(async () => {
        await loadUsers();
        await loadCurrentTaskOrAppointment();

        if (!actionForm.value) {
            return;
        }

        actionForm.value.addOverlayEventListener('exit', () => {
            redirectToDetail();
        });

        if (actionForm.value.open) {
            return;
        }

        actionForm.value.openOverlay();
    });

    const setEndTime = () => {
        if (form.value.startDateChosen) {
            const endDate = new Date(form.value.startDateChosen.toString());
            endDate.setHours(endDate.getHours() + 1);
            form.value.endDateChosen = endDate;
        }
    };

    const fillForm = () => {
        if (task.value) {
            form.value.isTask = true;
            form.value.realworksEnabled = false; // TODO: find endpoint for;
            form.value.informAssignedTo = false;
            form.value.type = { value: task.value.type as TaskType, label: task.value.type?.label as string };
            form.value.responsible = task.value.assignedUsers;
            form.value.startDateChosen = task.value.dueDateTime;
            form.value.endDateChosen = initialEndDate;
            form.value.comment = task.value.comment ?? '';
        }

        if (appointment.value) {
            form.value.isTask = false;
            form.value.realworksEnabled = false; // TODO: find endpoint for;
            form.value.informAssignedTo = false;
            form.value.type = { value: appointment.value.type as AppointmentType, label: appointment.value.type?.label as string };
            form.value.responsible = appointment.value.assignedUsers;
            form.value.startDateChosen = appointment.value.startDateTime;
            form.value.endDateChosen = appointment.value.endDateTime ?? initialEndDate;
            form.value.comment = appointment.value.comment ?? '';
        }

        if (!task.value && !appointment.value) {
            form.value.isTask = 'type' in route.query && route.query.type === 'task';
            form.value.realworksEnabled = false; // TODO: find endpoint for;
            form.value.informAssignedTo = false;
            form.value.type = defaultTypeValue.value;
            form.value.responsible = [];
            form.value.startDateChosen = initialStartDate;
            form.value.endDateChosen = initialEndDate;
            form.value.comment = '';

            // The form starts afresh here (on opening, and when the route changes to another kind of action)
            creation = startTaskCreation(form.value);
        }
    };

    const loadCurrentTaskOrAppointment = async () => {
        task.value = null;
        appointment.value = null;

        if (actionType.value === 'task' && actionId.value) {
            task.value = await client.get(Task, new TaskId(actionId.value));
            lead.value = task.value.lead;
        }

        if (actionType.value === 'appointment' && actionId.value) {
            appointment.value = await client.get(Appointment, new AppointmentId(actionId.value));
            lead.value = appointment.value.lead;
        }

        if (!actionType.value) {
            lead.value = await client.get(Lead, new LeadId(route.params.leadId.toString()));
        }

        fillForm();
    };

    const loadTasksAndAppointments = async () => {
        if (chosen.value <= 0) {
            return;
        }

        await taskCollection.value.load({
            'assignedUsers.id[]': responsibleUserIds.value,
            'dueDateTime[before]': (() => {
                const newDate = new Date(form.value.startDateChosen);
                newDate.setHours(23, 59, 59, 999);
                return newDate;
            })(),
            'dueDateTime[after]': (() => {
                const newDate = new Date(form.value.startDateChosen);
                newDate.setHours(0, 0, 0, 0);
                return newDate;
            })(),
            pagination: false,
        });
        await appointmentCollection.value.load({
            'assignedUsers.id': responsibleUserIds.value,
            'startDateTime[before]': (() => {
                const newDate = new Date(form.value.startDateChosen);
                newDate.setHours(23, 59, 59, 999);
                return newDate;
            })(),
            'startDateTime[after]': (() => {
                const newDate = new Date(form.value.startDateChosen);
                newDate.setHours(0, 0, 0, 0);
                return newDate;
            })(),
            pagination: false,
        });
    };

    const loadUsers = async () => {
        if (!lead.value) {
            return;
        }

        userCollection.value = await client.getSubResources(
            lead.value.assignee.team as Team,
            User,
            'available-users',
        );
    };

    const showDeleteConfirmation = () => {
        deleteConfirmDialog.value?.openOverlay();
    };

    const deleteAction = async (event: ButtonStateChangedEvent) => {
        const closeNotification = notifySaving(undefined, 0);
        try {
            await ActionAPI.delete(actionId.value);
            eventBus.dispatch('resource-manipulated', form.value.isTask ? 'Task' : 'Appointment');

            notifyDeleted(`De ${actionLabel.value} is verwijderd`);
            event.button.setState(ButtonState.completed);
            deleteConfirmDialog.value?.closeOverlay();
            if (actionForm.value) {
                actionForm.value.dispatchOverlayEvent('exit');
            }
        } catch (error) {
            notifyError(`De ${actionLabel.value} kon niet verwijderd worden`);
            event.button.setState(ButtonState.content);
        } finally {
            if (closeNotification) {
                closeNotification();
            }
        }
    };

    const onSave = async () => {
        if (!lead.value || !form.value.startDateChosen || !form.value.type || !client.session.userId) {
            return;
        }

        const stoppedCreation = stopTaskCreation(creation, form.value);

        try {
            let command;

            if (form.value.isTask) {
                command = {
                    referral: createResourceIdentifier(ReferralAPI.collectionName, lead.value.id.value),
                    id: task.value ? task.value.id.value : uuid(),
                    type: form.value.type.value?.value,
                    actionDate: form.value.startDateChosen,
                    actionEndDate: null,
                    comment: form.value.comment,
                    completed: false,
                    assignedTo: responsibleUserIds.value,
                    createdBy: createResourceIdentifier(UserAPI.collectionName, client.session.userId.value),

                    // gaat direct command in, is geen onderdeel van api model
                    informAssignedTo: form.value.informAssignedTo,
                };
            } else {
                command = {
                    referral: createResourceIdentifier(ReferralAPI.collectionName, lead.value.id.value),
                    id: appointment.value ? appointment.value.id.value : uuid(),
                    actionDate: form.value.startDateChosen,
                    actionEndDate: form.value.endDateChosen,
                    comment: form.value.comment,
                    type: 'meeting',
                    appointmentType: form.value.type.value?.value,
                    completed: false,
                    assignedTo: responsibleUserIds.value,
                    createdBy: createResourceIdentifier(UserAPI.collectionName, client.session.userId.value),

                    // gaat direct command in, is geen onderdeel van api model
                    informAssignedTo: form.value.informAssignedTo,
                };

                if (command.appointmentType === 'contact') {
                    command.appointmentType = 'customer';
                }
            }

            if (isExistingAction.value) {
                await ActionAPI.update(command.id, command);
            } else {
                await ActionAPI.create(command);
                sendTaskTiming(stoppedCreation);
                creation = undefined;
            }

            if (form.value.isTask) {
                eventBus.dispatch('resource-manipulated', 'Task');
            } else {
                eventBus.dispatch('resource-manipulated', 'Appointment');
            }

            redirectToDetail();
        } catch (errors) {
            notify({
                component: NotificationBlock,
                props: {
                    color: Color.red500,
                    title: 'Er is iets fout gegaan tijdens het opslaan',
                    text: errors,
                },
                duration: 0,
            });
        }
    };

    const redirectToDetail = () => {
        router.push(createRouteLocation({
            name: 'LeadDetail',
            params: {
                leadId: lead.value?.id.value,
            },
        }, 'contact'));
    };

    watch(startDateChosen, async (newDate, oldDate) => {
        if (newDate?.getTime() === oldDate?.getTime()) {
            return;
        }

        setEndTime();

        await loadTasksAndAppointments();
    });

    watch(chosen, async () => {
        await loadTasksAndAppointments();
    });

    watch(lead, async () => {
        await loadUsers();
    });
</script>

<style scoped lang="scss">
.sidesheet-header {
    padding: size(md);
    background-color: color(gray-200);
    border-bottom: 1px solid color(gray-300);
    width: 100%;
}

.action-sidesheet {
    height: 100%;

    &__toggles {
        width: 100%;
        display: flex;
        justify-content: flex-end;
        padding: size(md);
        border-bottom: 1px solid color(gray-300);
        background-color: color(brand-white);
    }

    &__form {
        width: 100%;
        padding: size(md);
        display: flex;
        flex-wrap: wrap;
        gap: size(md);
    }

    &__actions {
        width: 100%;
        padding: size(md);
        display: flex;
        gap: size(md);
        justify-content: flex-end;
    }

    &__calendar {
        width: 100%;
        padding: size(md);
        border-left: 1px solid color(gray-300);
    }

    &__grid-area {
        align-items: flex-start;
        align-content: flex-start;
        background-color: color(gray-200);
    }

    &__time-select {
        display: grid;
        width:100%;
        grid-template-columns: 4fr 2fr .25fr 2fr;
        gap: size(sm);
        align-items: flex-end;

        & > span {
            height: size(xl);
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }
}

@media only screen and (max-width: 1439px) {
    .action-sidesheet__time-select {
        grid-template-columns: 2fr .25fr 2fr;

        & *:first-child {
            grid-column: span 3;
        }

    }
}
</style>
